import { render, staticRenderFns } from "./NomRegistre.vue?vue&type=template&id=6008d38e&scoped=true&"
import script from "./NomRegistre.ts?vue&type=script&lang=ts&"
export * from "./NomRegistre.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008d38e",
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTh,QTr,QTd,QToggle,QDialog,QCard,QBar,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTh,QTr,QTd,QToggle,QDialog,QCard,QBar,QCardSection}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
